export default "__VITE_ASSET__COzypd3I__"